import anime from 'animejs/lib/anime.min.js';
import EventEmitter from "./event-emitter";

export default class Dropdown extends EventEmitter {
	constructor($menu, $trigger, options = {}) {
		super(options);
		this.$menu = $menu;
		this.$trigger = $trigger;
		this.$selecteValueOutput = null;
		this.$eventTarget = this.$menu; // For event emitter purposes

		this.isFirefox = document.body.classList.contains('-firefox');

		this.id = null;
		this.visible = false;

		this.BEFORE_SHOW_EVENT = 'beforeShow';

		this.init();
	}

	init() {
		if (this.$trigger == null) {
			throw new Error('Dropdown: trigger is missing');
		}

		if (this.$menu == null) {
			throw new Error('Dropdown: menu is missing');
		}

		if (
			!this.$menu.dataset ||
			!this.$menu.dataset.dropdownMenu
		) {
			throw new Error('Dropdown: data-dropdown-menu attribute is missing on menu element');
		}

		if (
			!this.$trigger.dataset ||
			!this.$trigger.dataset.dropdownTrigger
		) {
			throw new Error('Dropdown: data-dropdown-trigger attribute is missing on trigger element');
		}

		if (this.$menu.dataset.dropdownMenu !== this.$trigger.dataset.dropdownTrigger) {
			throw new Error('Dropdown: data-dropdown-menu and data-dropdown-trigger attribute values must be equal');
		}

		this.$selectIcon = this.$trigger.querySelector('.icon-select');

		this.id = this.$menu.dataset.dropdownMenu;

		this.$menu.style.transform = 'scale(1)';

		this.$trigger.addEventListener('click', () => {
			if (this.visible) {
				this.hide();
			} else {
				this.show();
			}
		});

		window.addEventListener('click', e => {
			if (e.target.closest('[data-dropdown-menu]') || e.target.closest('[data-dropdown-trigger]')) {
				return;
			}

			if (this.visible) {
				this.hide();
			}
		});

		super.init();
	}

	show() {

		this.$trigger.classList.add('-active');

		this.$menu.style.opacity = 0;
		this.$menu.style.display = 'flex';

		// beforeShow event fires after the display property is set to not none value
		// for availability of getting element height before it shows
		this.dispatchEvent(this.BEFORE_SHOW_EVENT);

		const animationConfig = {
			targets: this.$menu,
			opacity: 1,
			duration: 240,
			easing: 'cubicBezier(0.32, 0.08, 0.24, 1)'
		};

		if (!this.isFirefox) {
			animationConfig.scale = [.95, 1];
		}

		/* Animate */
		anime(animationConfig);

		this.visible = true;
	}

	hide() {
		this.$trigger.classList.remove('-active');

		anime({
			targets: this.$menu,
			opacity: 0,
			duration: 100,
			easing: 'cubicBezier(0.32, 0.08, 0.24, 1)',
			complete: (anim) => {
				if (anim.completed) {
					this.$menu.style.display = 'none';
				}
			}
		});

		this.visible = false;
	}
}